import React, { useEffect, useRef, useState } from "react";
import { Card, CardContent, Button, Typography, Grid, Box, Alert, DialogContent, DialogActions, Dialog, IconButton, DialogTitle, Divider, CircularProgress } from "@mui/material";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import PageContainer from "./Pagecontainer";
import { IconAlertTriangle, IconCrown, IconDownload, IconX } from "@tabler/icons-react";
import ScheduleDemo from "./demo";
import dayjs from "dayjs";
import Cookies from "js-cookie";
const Documents = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const projectid = params.get("id");
  const ProjectName = params.get("name");
  const socketRef = useRef(null);
  const delayref = useRef(null);

  // const colors = ['#3b7197', '#75946c', '#74bde0', '#ca9f44'];
  // const colors = ['#eeedff', '#fff8e6', '#ecf9ff', '#faedf6']

  const colors = [
    "#F5FAFD", // lighter blue
    "#F4FDF0", // lighter green
    "#FFF6ED", // lighter orange
    "#F4F4FB", // lighter purple
    "#EDF9F9", // lighter teal
    "#FFFDEB", // lighter yellow
    "#FDF3F3", // lighter pink/red
    "#F1F6F0", // lighter olive
    "#FFF1EC", // lighter coral
    "#F3F2FF", // lighter indigo
  ];
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [docData, setDocData] = useState({});
  const [error, seterror] = useState("")
  const [GeneratingPopup, setGeneratingPopup] = useState(false)
  const [ErrorPopup, setErrorPopup] = useState(false)
  const [Errorpopup, setErrorpopup] = useState(false)
  const [falseCount, setFalseCount] = useState(0);
  const [Exportloader, setExportloader] = useState(false)
  const documentsData = [
    { id: 1, name: "Executive Summary", key: "doc_exec", text: "A high-level overview of the business idea, highlighting key aspects in a brief, compelling format.", status: docData?.doc_exec, Created: docData?.doc_exec_created_at, Edited: docData?.doc_exec_updated_at },
    { id: 2, name: "Short Business Plan", key: "doc_short", text: "A short strategic plan outlining key business elements like problem, solution, and revenue model.", status: docData?.doc_short, Created: docData?.doc_short_created_at, Edited: docData?.doc_short_updated_at },
    { id: 3, name: "Comprehensive Business Plan", key: "doc_full", text: "A comprehensive document detailing business strategy, market analysis , launch & scale and raise capital strategy.", status: docData?.doc_full, Created: docData?.doc_full_created_at, Edited: docData?.doc_full_updated_at },
    { id: 4, name: "AI Investor Deck", key: "doc_invest", text: "A visually engaging presentation showcasing the business opportunity, financials, and growth potential for investors.", status: docData?.doc_invest, Created: docData?.doc_invest_created_at, Edited: docData?.doc_invest_updated_at }
  ];
  const userinfo = JSON.parse(Cookies.get('user-info'));
  const [setupdata, setsetupdata] = useState()
  const isBillingAdded = setupdata?.is_billing_added
  const getSetupData = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/apiV1/set-up/')
      if (response.status === 200) {
        setsetupdata(response.data)
       setLoading(false);

      }
    }
    catch (err) {
      console.log(err?.response?.data?.message);
    setLoading(false);


    }
  }
  useEffect(() => {
    getSetupData();
  }, []);
  const GenerateDoc = async (data) => {
    // setLoading1(true);
    // setGeneratingPopup(true)
    try {
      const req = {
        project_id: projectid,
        doc_type: data
      };
      const response = await axios.post("/apiV1/generate-document/", req);
      if (response.status === 200) {
        setLoading1(false);
        setGeneratingPopup(false)
        GetDocinfo();
      }
    } catch (error) {
      console.error(error);
      seterror(error.response.data.message)
      setLoading1(false);
      setGeneratingPopup(false)
    }
  };
  const checkgenerateAll = async (data) => {
    setLoading(true)
    try {
      const config2 = {
        headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==` }
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL2}/apiV1/update-customer-subs/?user_id=${userinfo.id}&no_total_documents=${falseCount}`,
        {},
        config2
      );
      if (response.status === 200) {
        hanldeGenerateAll()
        setLoading(false)
      }
    }
    catch (error) {
      console.log(error)
      setErrorpopup(true)
      setLoading(false)
    }
  }
  const CheckSubcriptionPro = async (data) => {
    // if (isFreeTrial === true && data !=="doc_exec") {
    //   setErrorpopup(true)
    //   return
    // }
    setLoading(true);
    try {
      const config2 = {
        headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==` }
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL2}/apiV1/update-customer-subs/?user_id=${userinfo.id}&no_total_documents=${1}`,
        {},
        config2
      );
      if (response.status === 200) {
        GenerateDoc(data)
       setLoading(false);

      }
    }
    catch (error) {
      console.log(error)
      setErrorpopup(true)
       setLoading(false);
    }
  }
  const GetDocinfo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/apiV1/get-document/?project_id=${projectid}`);
      if (response.status === 200) {
        setDocData(response.data.data);
        const falseCount = Object.values(response.data.data).filter(val => val === false).length;
        setFalseCount(falseCount);
        setLoading(false)
      }
    } catch (err) {
      console.error(err);
      if (err.response.status === 403) {
        setErrorPopup(true)
      }
      setLoading(false)
    }
  };
  useEffect(() => {
    GetDocinfo();

    const token = sessionStorage.getItem("AdminToken");
    // const socket = new WebSocket(`ws://192.168.94.230:8000/ws/documents/status/${projectid}/?token=${token}`);
    const baseApiUrl = process.env.REACT_APP_WEBSOCKET_URL;
    const wsProtocol = baseApiUrl.startsWith("https") ? "wss" : "ws";
    const wsBaseUrl = baseApiUrl.replace(/^http(s?):\/\//, `${wsProtocol}://`);

    const socket = new WebSocket(`${wsBaseUrl}/ws/documents/status/${projectid}/?token=${token}`);
    socketRef.current = socket;
    socket.onopen = () => {
      console.log("WebSocket connected");
      socket.send(JSON.stringify({ project_id: projectid }));

      delayref.current = setInterval(() => {
        if (socket.readyState === WebSocket.OPEN) {
          socket.send(JSON.stringify({ project_id: projectid }));
        }
      }, 5000);
    };

    socket.onmessage = (event) => {
      try {
        const response = JSON.parse(event.data);
        const newDocData = response.data;
        setDocData((prev) => {
          const updated = { ...prev, ...newDocData };
          const falseCount = Object.values(updated).filter(val => val === false).length;
          setFalseCount(falseCount);
          return updated;
        });
      } catch (err) {
        console.error("Invalid WebSocket message format", err);
      }
    };


    socket.onerror = (error) => {
      console.error("WebSocket error", error);
    };

    socket.onclose = () => {
      console.log("WebSocket disconnected");
      clearInterval(delayref.current);
    };

    return () => {
      socket.close();
      clearInterval(delayref.current);
    };
  }, [projectid]);
  const hanldeGenerateAll = async () => {
    // setLoading(true)
    setGeneratingPopup(true)
    try {
      let req = {
        project_id: projectid,
        doc_type: "all"
      }
      const response = await axios.post('/apiV1/generate-document/', req)
      if (response.status == 200) {
        // setLoading(false)
         setGeneratingPopup(false)
        // GetDocinfo()
      }
    } catch (err) {
      console.log(err);
      //  setLoading(false)
      setGeneratingPopup(false)
      seterror(err.response.data.message)

    }
  }
  const handleDownloadAll = async () => {
    setLoading(true);
    try {
      const req = {
        project_id: projectid,
        doc_type: "all"
      };

      const response = await axios.post('/apiV1/download-doc/', req, {
        responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "project_documents.zip";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error downloading ZIP file:", error);
    } finally {
      setLoading(false);
    }
  };


  const allGenerated = documentsData.every(doc => doc.status !== false);
  const isGenerating = documentsData.some(doc => doc.status === "Generating");
  useEffect(() => {
    if (projectid) {
    // getSetupData();
      GetDocinfo();
    }
  }, [projectid]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     GetDocinfo();
  //   }, 30000);

  //   return () => clearInterval(interval);
  // }, []);
const today = new Date();
const [loadingDoc, setLoadingDoc] = useState(null);

const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}${today.getFullYear()}`;
  const handleDownload = async (ext, doctype) => {
    try {
      setExportloader(true)
      setLoadingDoc(doctype);
      const req = {
        doc_type: doctype,
        project_id: projectid
      };

      const response = await axios.post('/apiV1/download-doc/', req, {
        responseType: 'blob'
      });

      // let fileExtension = (doctype === 'doc_exec' || doctype === 'doc_full') ? 'docx' : 'pdf';
         let fileExtension = "pdf"
      const contentDisposition = response.headers['content-disposition'];
      let filename = `${ProjectName}_${ext}_${formattedDate}.${fileExtension}`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match) filename = match[1];
      }

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setLoadingDoc(null);
      setExportloader(false)
    } catch (error) {
      console.error('Error downloading file:', error);
      setLoadingDoc(null);
      setExportloader(false)
    }
  };
  return (
    <>
      {Exportloader && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <BeatLoader color=" #07659c" size={15} />
        </Box>
      )}
      <PageContainer title="SmartInvestorDeck | Documents">
      <ScheduleDemo showBanner={true} />
        <Box
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 5, }} >
          {/* Project Name */}
          <Typography sx={{ ml: { xs: 2, sm: 2 }, fontSize: 28,  fontWeight: "bold",color: "#07659c",  }}> {ProjectName}</Typography>
          <Box sx={{ display: "flex", gap: 2, pr: 6 }}>
            <Button variant="contained"
              color="primary"
              className="button2"
              sx={{ maxWidth: "180px" }}
              onClick={() => navigate(`/documents/answers?id=${projectid}&name=${ProjectName}`, { state: {   projectId: projectid,projectName:ProjectName } })}>
              QA / ANS
            </Button>

            {!allGenerated && !isGenerating && <Button
              variant="contained" color="primary" className="button2"
              sx={{ maxWidth: "180px" }}
              onClick={checkgenerateAll}
            >
              Generate All
            </Button>}
          </Box>
        </Box>
        {isBillingAdded === false ? <>
        <Box>
          <Alert severity="warning" sx={{ mx: 5, mt: 2 }}>
            Please add billing information to download documents.
          </Alert>
        </Box></> : ""}
        <Grid
          container
          spacing={3}
          sx={{ p: 5, display: "flex", justifyContent: "center", alignItems: "center" }}
        >

          {!loading ? (
            <>
              <Grid container spacing={3}>
                {documentsData.map((doc, index) => {
                  const doc_exec = documentsData.find(d => d.key === "doc_exec")?.status === true;
                  const doc_short = documentsData.find(d => d.key === "doc_short")?.status === true;

                  let isDisabled = false;

                  if (doc.key === "doc_short") {
                    isDisabled = !doc_exec;
                  } else if (doc.key === "doc_full" || doc.key === "doc_invest") {
                    isDisabled = !(doc_exec && doc_short);
                  }
                  // const isStatusTrue = (s) => s === true || s === "true";
                  // const isDisabled = (() => {
                  //   if (index === 0 || index === 1) return false;
                  //   return !(isStatusTrue(documentsData[0]?.status) && isStatusTrue(documentsData[1]?.status));
                  // })();

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      key={doc.id}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Card
                        sx={{
                          maxHeight: 500,
                          minHeight: 220,
                          width: { xs: "100%", sm: "100%" },
                          borderRadius: 2,
                          mt: 2,
                          p: 1,
                          backgroundColor: colors[index % colors.length],
                          // boxShadow: "0px 0px 8px 0px #efebeb",
                          border: "1px solid #ededed",
                          // boxShadow: 1,
                          "&:hover": {
                            boxShadow: "0px 0px 15px 0px #efebeb",
                          },
                          overflow: "hidden",
                          mx: "auto",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <CardContent sx={{ flexGrow: 1 }}>
                          <Typography variant="h6"
                            // sx={{ fontWeight: 600, color: colors[index % colors.length] }}
                            sx={{ fontWeight: 600, color: "#000" }}
                          >
                            {doc.name}
                          </Typography>
                          <Typography sx={{ mt: 2 }}>{doc.text}</Typography>
                        </CardContent>

                       <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" }, 
                            gap: 1.5,
                            pb: 2,
                            px: 2,
                            justifyContent: { sm: "space-between" },
                            alignItems: { sm: "center", xs: "flex-start" },
                          }}
                        >
                          {doc.status === "Generating" ? (
                            <Button
                              variant="contained"
                              sx={{ border: "none", backgroundColor: "#07659c", color: "#fff" }}
                              disabled
                            >
                              Generating...
                            </Button>
                          ) : doc.status ? (
                            <Button
                              variant="contained"
                              sx={{ border: "none", backgroundColor: "#07659c", color: "#fff" }}
                              onClick={() => navigate(`/viewdocument?id=${projectid}&type=${doc.key}&ext=${doc.name}&name=${ProjectName}`)}
                              disabled={isDisabled || loading}
                            >
                              {loading ? <BeatLoader size={20} color="#4a77f8" /> : "View"}
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              sx={{ border: "none", backgroundColor: "#07659c", color: "#fff" }}
                              onClick={() => CheckSubcriptionPro(doc.key)}
                              disabled={isDisabled || loading}
                            >
                              {loading ? <BeatLoader size={20} color="#4a77f8" /> : "Generate"}
                            </Button>
                          )}
                         {doc.Created &&<Typography sx={{ color: "#696363" }}>
                            Created: {doc.Created ? dayjs(doc.Created).format("MM-DD-YYYY, hh:mm A") : "—"}
                          </Typography>}
                          {doc.Edited &&<Typography sx={{ color: "#696363" }}>
                            Last Edit: {doc.Edited ? dayjs(doc.Edited).format("MM-DD-YYYY, hh:mm A") : "—"}
                          </Typography>}
                          {/* {doc.status === true ? <Typography onClick={() => { handleDownload(doc.name, doc.key) }} sx={{ cursor: "pointer"}}>
                            <IconDownload
                              color="green"
                              size={30}
                            />
                          </Typography> : <IconDownload disabled color="#ccc" size={30} />} */}
                          {doc.status === true && isBillingAdded ? (
                            loadingDoc === doc.key ? (
                              <CircularProgress size={28} color="success" />
                            ) : (
                              <Typography
                                onClick={() => handleDownload(doc.name, doc.key)}
                                sx={{ cursor: "pointer" }}
                              >
                                <IconDownload color="green" size={30} />
                              </Typography>
                            )
                          ) : (
                            <IconDownload color="#ccc" size={30} />
                          )}



                        </Box>

                      </Card>
                    </Grid>
                  );
                })}

              </Grid>
              <Box sx={{ mt: 2 }}>
                {error && <Alert severity="error">{error}</Alert>}
              </Box>

              {/* <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end", mt: 3, pr: 11 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ maxWidth: "180px" }}
                onClick={allGenerated ? handleDownloadAll : hanldeGenerateAll}
              >
                {allGenerated ? "Download All" : "Generate All"}
              </Button>
            </Box> */}

            </>
          ) : (
            <Box sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
                position: "fixed",
                top: 0,
                left: 0,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                zIndex: 9999,
              }}>
              <BeatLoader size={36} color="#07659c" />
            </Box>
          )}
        </Grid>
        <Dialog
          open={GeneratingPopup}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              setGeneratingPopup(false);
            }
          }}
          aria-labelledby="success-dialog-title"
          aria-describedby="success-dialog-description"
          maxWidth="sm"
          fullWidth
        >
          <DialogContent dividers className='text-center py-3'>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginTop: '20px', marginBottom: '10px' }}>
              {/* <BeatLoader
                size={24}
                color={"#07659c"}
                loading={GeneratingPopup}
              /> */}
            </Box>
            <Typography variant="h6" className='blue_dark_text font_weight_700'>
              Generation in progress. Please wait for a few seconds.....
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={() => { setGeneratingPopup(false); setLoading(false); GetDocinfo() }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={ErrorPopup}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="error-dialog-title" align="center" >
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: "#fff3cd",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  marginBottom: 2,
                }}
              >
                <IconAlertTriangle size={32} color="#ff9800" />
              </Box>
            </Box>
            <Typography variant="h6" fontWeight="bold">
              Error
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography id="error-dialog-description" align="center">
              You do not have permission to perform this action.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2, marginBottom: 1 }}>
            <Button
              variant="contained"
              color="error"
              sx={{ backgroundColor: "#c63037", border: "none" }}
              onClick={() => { setErrorPopup(false); navigate('/dashboard') }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={Errorpopup}
          onClose={() => setErrorpopup(false)}
          aria-labelledby="error-dialog-title"
          aria-describedby="error-dialog-description"
          PaperProps={{
            sx: { borderRadius: "16px", padding: "16px" },
          }}
          fullWidth
          maxWidth="sm"
        >
          {/* Close Button */}
          <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">
              Upgrade Plan
            </Typography>
            <IconButton size="small" onClick={() => setErrorpopup(false)}>
              <IconX />
            </IconButton>
          </Box>
      <Divider/>
          {/* Error Icon & Title */}
          <DialogTitle id="error-dialog-title" align="center">
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: "#fff3cd",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  marginBottom: 2,
                }}
              >
                <IconCrown size={32} color="#ff9800" />
              </Box>
            </Box>
            <Typography variant="h6" fontWeight="bold">
              Upgrade
            </Typography>
          </DialogTitle>

          {/* Error Message */}
          <DialogContent>
            <Typography id="error-dialog-description" align="center">
            Your subscription limits have been reached. Please upgrade your account for uninterrupted access and enhanced features.
            </Typography>
          </DialogContent>

          {/* Close Button */}
          <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2, marginBottom: 1 }}>
            <Button
              variant="contained"
              color="error"
              sx={{ backgroundColor: "#c63037", border: "none" }}
              onClick={() => setErrorpopup(false)}
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="error"
              className="button2"
              onClick={() => navigate('/plans')}
            >
              Upgrade Now
            </Button>
          </DialogActions>
        </Dialog>
      </PageContainer>
    </>
  );
};

export default Documents;
